import cx from 'classnames'
import { useContext } from 'react'
import { SanityContentFragment } from '@data/sanity/queries/types/content'
import { SanityMuxVideo } from '@data/sanity/queries/types/video'
import { PageHeroContext } from '@lib/page-hero-context'
import MuxVideo from '@components/video/mux-video'
import HeroCaseVideoCarouselCaseContent from './hero-case-video-carousel-case-content'

interface HeroCaseVideoCarouselItemProps {
  slideHeroContent?: SanityContentFragment
  muxVideo?: SanityMuxVideo
  isSlideTransition: boolean
  index: number
  activeIndex: number
}

const animationDuration = 1000

const HeroCaseVideoCarouselItem = ({
  slideHeroContent,
  muxVideo,
  isSlideTransition,
  index,
  activeIndex,
}: HeroCaseVideoCarouselItemProps) => {
  const { heroCaseVideoCarouselDisabled } = useContext(PageHeroContext)

  const isActive = activeIndex === index

  if (heroCaseVideoCarouselDisabled && !isActive) {
    return null
  }

  return (
    <div className="slide absolute top-0 w-full h-full">
      <HeroCaseVideoCarouselCaseContent
        slideHeroContent={slideHeroContent}
        isSlideTransition={isSlideTransition}
        index={index}
        activeIndex={activeIndex}
      />

      {!!muxVideo && (
        <div
          className={cx('h-full w-full transition-opacity', {
            'opacity-0': !isActive,
            'opacity-100': isActive,
          })}
          style={{
            transitionDuration: `${animationDuration}ms`,
            transitionDelay: `${animationDuration}ms`,
          }}
        >
          <div className="absolute inset-0 z-[1] bg-pageText transition-opacity duration-200 bg-opacity-50" />
          <MuxVideo
            video={muxVideo}
            showControls={false}
            autoplay={true}
            autoplayOnHover={false}
            openModalOnClick={false}
            muted={true}
            loop={true}
            className="h-full"
          />
        </div>
      )}
    </div>
  )
}

export default HeroCaseVideoCarouselItem
